// UsagePage.js
import React, { useState } from "react";
import { Link } from "react-router-dom";

function UsagePage() {
  const [activeSection, setActiveSection] = useState(null);

  const handleClick = (section) => {
    setActiveSection(section);
  };

  return (
    <div className="container mt-5">
      <div className="card shadow-lg">
        <div className="card-body">
          <h3 className="card-title mb-4">📘 วิธีใช้งาน Dashboard</h3>

          <ol className="list-group list-group-numbered">
            <li className="list-group-item">
              <Link to="#" onClick={() => handleClick("group")} className="text-decoration-none">
                <strong>จัดกลุ่ม:</strong> มีไว้จัดกลุ่มตามรหัสเครื่อง โดย 1 กลุ่มต้องมีอย่างน้อย 2 เครื่อง เพื่อใช้แจ้งเตือนหากันเอง
              </Link>
            </li>
            <li className="list-group-item">
              <Link to="#" onClick={() => handleClick("report")} className="text-decoration-none">
                <strong>รายงาน:</strong> มีไว้ดูประวัติย้อนหลังการเกิดแผ่นดินไหว ที่เครื่องเคยแจ้งเตือนไปแล้ว
              </Link>
            </li>
            <li className="list-group-item">
              <Link to="#" onClick={() => handleClick("permission")} className="text-decoration-none">
                <strong>กำหนดสิทธิ:</strong> มีไว้กำหนดสิทธิในการแจ้งเตือนและรับแจ้งเตือนของแต่เครื่องในกลุ่ม
              </Link>
            </li>
            <li className="list-group-item">
              <Link to="#" onClick={() => handleClick("time")} className="text-decoration-none">
                <strong>กำหนดเวลา:</strong> มีไว้เพื่อกำหนดเวลาทำงานของเครื่องโดยปรกติจะทำงาน 24 ชั่วโมง
              </Link>
            </li>
            <li className="list-group-item">
              <Link to="#" onClick={() => handleClick("setting")} className="text-decoration-none">
                <strong>ตั้งค่า:</strong> มีไว้เพื่อตั้งค่า Wi-Fi เมื่อนำเครื่องมาเสียบผ่านสาย USB ที่คอม
              </Link>
            </li>
          </ol>

          <div className="mt-4 text-muted">
            หากมีข้อสงสัยเพิ่มเติม กรุณาติดต่อเจ้าหน้าที่ผ่านหน้า <strong>Contact</strong>
          </div>
        </div>
      </div>

      {/* ✅ แสดงแต่ละ Card ตามหัวข้อที่คลิก */}
      {activeSection === "group" && (
        <div className="card shadow mt-4">
          <img
            src="/manual1.png"
            className="card-img-top"
            alt="หน้ากำหนดกลุ่ม"
            style={{ maxHeight: "300px", objectFit: "contain", width: "100%" }}
          />
          <div className="card-body">
            <h5 className="card-title text-center">การจัดกลุ่มอุปกรณ์</h5>
            <p className="card-text">
              1 เลือกเมนูกำหนดกลุ่ม<br />
              2 จัดการกลุ่ม ใช้สำหรับลบกลุ่มที่ไม่ต้องการออกไป<br />
              3 เมื่อคลิกที่รหัสเครื่อง จะมีหน้าต่าง แก้ไขข้อมูลเครื่อง เช่น ชื่อ/มือถือ/สถานที่ <span style={{ color: "red" }}>จำเป็นต้องระบุให้ชัดเจน</span><br />
              4 เมื่อคลิกที่ชื่อกลุ่ม จะมีหน้าต่างให้เลือกกลุ่มหรือสร้างกลุ่มใหม่<br />
              5 เมื่อคลิกจะแสดงข้อมูลเครื่องที่เราใส่ไว้ในข้อ 3 เพื่อค้นหา<br />
              6 ช่องค้นหา ไว้ค้นหาข้อมูลทุก column ที่แสดง
            </p>
          </div>
        </div>
      )}

      {activeSection === "report" && (
        <div className="card shadow mt-4">
              <div
          id="reportCarousel"
          className="carousel slide"
          data-bs-ride="carousel"
          data-bs-interval="3000"
        >
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img
                  src="/manual2.png"
                  className="d-block w-100"
                  alt="ภาพรายงาน 1"
                  style={{ maxHeight: "300px", objectFit: "contain" }}
                />
              </div>
              <div className="carousel-item">
                <img
                  src="/manual3.png"
                  className="d-block w-100"
                  alt="ภาพรายงาน 2"
                  style={{ maxHeight: "300px", objectFit: "contain" }}
                />
              </div>
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target="#reportCarousel" data-bs-slide="prev">
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#reportCarousel" data-bs-slide="next">
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>

          <div className="card-body">
            <h5 className="card-title text-center">รายงาน</h5>
            <p className="card-text">
              1 เลือกเมนูรายงาน<br />
              2 เลือกหัวข้อ ว่าต้องการรายงานย้อนหลังจากที่ไหน และวันที่<br />
              3 สรุปข้อมูลในตาราง รูปแบบ Pie Chart<br /> 
              4 นำข้อมูลในตาราง แสดงตำแหน่งในแผนที่
            </p>
          </div>
        </div>
      )}


      {activeSection === "permission" && (
        <div className="card shadow mt-4">
          <img
            src="/manual4.png"
            className="card-img-top"
            alt="หน้ากำหนดสิทธิ"
            style={{ maxHeight: "300px", objectFit: "contain", width: "100%" }}
          />
          <div className="card-body">
            <h5 className="card-title text-center">กำหนดสิทธิ</h5>
            <p className="card-text">
              1 เลือกเมนูกำหนดสิทธิ<br />
              2 ปุ่มเลือก  <span style={{ color: "red" }}>กำหนดสิทธิในการส่ง</span> คือ ระบุให้เครื่องในกลุ่มตามสิทธิสามารถ  <span style={{ color: "red" }}>กดปุ่มที่หน้าจอ เพื่อแจ้งเตือนอะไรได้</span><br />
              3 ปุ่มเลือก <span style={{ color: "blue" }}>กำหนดสิทธิในการรับ</span> คือ ระบุให้เครื่องในกลุ่มตามสิทธิสามารถ <span style={{ color: "blue" }}>ส่งเสียงแจ้งเตือน อะไรได้</span><br />
              4 แสดงข้อมูลเครื่อง ในตารางเพื่อใช้ค้นหา <br />
              5 และ 6 ใช้เลือกแบบทั้งหมดหรือเฉพาะรายการ เพื่อกำหนดสิทธิ<br />
              7 สามารถเปลี่ยนสิทธิ โดยตรงเพียงคลิก ที่ปุ่ม<br />
              8 ช่องค้นหา ข้อมูลในตาราง
            </p>
          </div>
        </div>
      )}

      {activeSection === "time" && (
        <div className="card shadow mt-4">
          <img
            src="/manual5.png"
            className="card-img-top"
            alt="หน้ากำหนดเวลา"
            style={{ maxHeight: "300px", objectFit: "contain", width: "100%" }}
          />
          <div className="card-body">
            <h5 className="card-title text-center">กำหนดเวลา</h5>
            <p className="card-text">
              1 เลือกเมนูกำหนดเวลา<br />
              2 แสดงข้อมูลเครื่อง ในตารางเพื่อใช้ค้นหา <br />
              3 และ 4  ใช้เลือกแบบทั้งหมดหรือเฉพาะรายการ และ ตั้งเวลาทำงานทั้งหมดพร้อมกัน<br /> 
              5 ช่องค้นหา ข้อมูลในตาราง
            </p>
          </div>
        </div>
      )}

      {activeSection === "setting" && (
        <div className="card shadow mt-4">
           <img
            src="/manual6.png"
            className="card-img-top"
            alt="หน้ากำหนดเวลา"
            style={{ maxHeight: "300px", objectFit: "contain", width: "100%" }}
          />
          <div className="card-body">
            <h5 className="card-title text-center">ตั้งค่า</h5>
            <p className="card-text">
              1 เลือกเมนูตั้งค่า<br />
              2 นำเครื่องต่อสาย USB มาต่อแล้วเลือก COM ที่ใช้เชื่อมต่อ  <br />
              3 ใส่ช้อมูล wi-fi ที่จะให้เครื่องใช้งาน<br /> 
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default UsagePage;
